import {StyleRulesCallback, WithStyles, withStyles} from "@material-ui/core/styles";
import * as React from "react";

interface IProps {
    text: string
}

const styles: StyleRulesCallback = ({ palette, spacing }) => ({
    container: {
        borderRadius: 10,
        boxShadow: "0 2px 4px 0 rgba(226, 230, 236, 0.5)",
        backgroundColor: "#ffffff",
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1.5,
        color: "#35373a",
        padding: "2em",
        overflow: "auto",
        height: "45em"
}
});

@(withStyles(styles) as any)
export default class TextArea extends React.Component<
    IProps & Partial<WithStyles<any>>
    > {
    public render() {
        const { classes, text } = this.props;
        return <div className={classes!.container}>
            {text}
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/TextArea/TextArea.tsx